// Radha — generic single-sheet Excel export for the module panels. Shares the
// dynamic-imported, write-only SheetJS chunk with the CRM workbook export (see
// exportCrm.ts for the rationale on the npm advisories not applying here).
export async function exportTable(name: string, rows: Record<string, unknown>[]) {
  if (!rows.length) return;
  const XLSX = await import("xlsx");
  const wb = XLSX.utils.book_new();
  // Excel sheet names cap at 31 chars and forbid : \ / ? * [ ]
  const sheet = name.replace(/[:\\/?*[\]]/g, " ").slice(0, 31) || "Sheet1";
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), sheet);
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `radha-${slug}-${stamp}.xlsx`);
}
